// extracted by mini-css-extract-plugin
export default {"tabs-list":"Subtabs_tabs-list__Jn9zX","list-item":"Subtabs_list-item__6nzMw","active":"Subtabs_active__Eve+u"};